import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import {
  CAM_LICENSE_END_DATE,
  CAM_LICENSE_NO,
  CAM_LICENSE_START_DATE,
  FILLING_DUE_DATE,
  LAST_AGM_DATE,
  STATE_TAX_ID,
  FED_TAX_ID,
  formatFederalTaxId,
} from "./consts";
import { useGetCommunityLicenseInfo } from "@/services";
import { useEffect } from "react";
import { getRequiredFields } from "@/lib/utils";
import { schema } from "./validations";
import { useSelector } from "react-redux";
import { RootState } from "@/redux/store";

const useStep2 = () => {
  const form = useForm<any>({
    defaultValues: {
      [FED_TAX_ID]: undefined,
      [STATE_TAX_ID]: undefined,
      [CAM_LICENSE_NO]: undefined,
      [CAM_LICENSE_START_DATE]: undefined,
      [CAM_LICENSE_END_DATE]: undefined,
      [LAST_AGM_DATE]: undefined,
      [FILLING_DUE_DATE]: undefined,
    },
    resolver: zodResolver(schema),
  });

  // Dynamically determine required fields
  const requiredFields = getRequiredFields(schema);

  const communityData = useSelector(
    (state: RootState) => state.currentData.communityData
  );

  const {
    data: communityLicenseInfo,
    isLoading: isLicenseInfoLoading,
    isRefetching: isLicenseInfoRefetching,
  } = useGetCommunityLicenseInfo({
    community_id: communityData?.communityId || "",
    queryParams: {
      enabled: !!communityData?.communityId,
    },
  });

  useEffect(() => {
    if (communityLicenseInfo) {
      form.reset({
        [FED_TAX_ID]: communityLicenseInfo?.data?.[FED_TAX_ID]
          ? formatFederalTaxId(communityLicenseInfo?.data?.[FED_TAX_ID])
          : undefined,
        [STATE_TAX_ID]: communityLicenseInfo?.data?.[STATE_TAX_ID]
          ? formatFederalTaxId(communityLicenseInfo?.data?.[STATE_TAX_ID])
          : undefined,
        [CAM_LICENSE_NO]:
          communityLicenseInfo?.data?.camLicenseNumber || undefined,
        [CAM_LICENSE_START_DATE]:
          communityLicenseInfo?.data?.[CAM_LICENSE_START_DATE] || undefined,
        [CAM_LICENSE_END_DATE]:
          communityLicenseInfo?.data?.[CAM_LICENSE_END_DATE] || undefined,
        [LAST_AGM_DATE]:
          communityLicenseInfo?.data?.[LAST_AGM_DATE] || undefined,
        [FILLING_DUE_DATE]:
          communityLicenseInfo?.data?.[FILLING_DUE_DATE] || undefined,
      });
    }
  }, [communityLicenseInfo]);

  return {
    form,
    requiredFields,
    isLicenseInfoLoading,
    isLicenseInfoRefetching,
  };
};

export default useStep2;
